<template>
  <div class="token-body">
    <el-form
      :model="tokenForm"
      :rules="tokenRules"
      ref="ruleForm"
      label-width="100px"
      class="token-form"
      label-position="top"
    >
      <el-form-item>
        <div class="token-title">标准代币<a class="tips" href="https://tokenbox.tools/stardand.html" target="_blank">教程</a></div>
        <div class="token-advantages">
          <span>标准ERC20合约</span>
          <span>AVE检测全绿</span>
        </div>
      </el-form-item>

      <el-form-item label="代币全称:" prop="name">
        <el-input
          v-model="tokenForm.name"
          placeholder="请输入全称"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="代币简称:" prop="symbol">
        <el-input
          v-model="tokenForm.symbol"
          placeholder="请输入简称"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="发行量:" prop="total">
        <el-input
          v-model.number="tokenForm.total"
          placeholder="请输入数值"
          oninput="value=value.replace(/[^\d]/g,'')"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="精度:" prop="decimals">
        <template slot="label" >
          精度
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              此处精度为小数点后的位数，通常为18
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <el-input-number
          v-model="tokenForm.decimals"
          :step="1"
          :min="1"
          :max="18"
          class="token-inputNumber"
        ></el-input-number>
      </el-form-item>

      <!-- 选填内容 -->
      <el-form-item class="token-optionalContent">
        <template slot="label">
          选填内容
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              选填内容<br /><br />
              ①&nbsp;官网链接<br /><br />
              ②&nbsp;telegram群组<br /><br />
              ③&nbsp;twitter<br /><br />
              ④&nbsp;Discord<br /><br />
              ⑤&nbsp;简介
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
          <span
            class="optionalContent-btn"
            @click="optionalContent = true"
            v-if="!optionalContent"
            >展开</span
          >
          <span
            class="optionalContent-btn"
            @click="optionalContent = false"
            v-else
            >收起</span
          >
        </template>
      </el-form-item>

      <el-form-item label="官网链接:" prop="website" v-if="optionalContent">
        <el-input
          v-model="tokenForm.website"
          placeholder="请输入官网链接"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item
        label="telegram群组:"
        prop="telegram"
        v-if="optionalContent"
      >
        <el-input
          v-model="tokenForm.telegram"
          placeholder="请输入telegram链接"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="twitter:" prop="twitter" v-if="optionalContent">
        <el-input
          v-model="tokenForm.twitter"
          placeholder="请输入twitter链接"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="Discord:" prop="discord" v-if="optionalContent">
        <el-input
          v-model="tokenForm.discord"
          placeholder="请输入discord链接"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="简介:" prop="introduction" v-if="optionalContent">
        <el-input
          v-model="tokenForm.introduction"
          placeholder="选填,简介最多200字"
          type="textarea"
          maxlength="200"
          show-word-limit
          rows="5"
          clear
        ></el-input>
      </el-form-item>

      <!-- <el-form-item v-if="gasConfig>0"> -->
      <div v-if="gasConfig && gasConfig.price > 0" class="token-cost">
        费用：{{ gasConfig.price }} {{ gasConfig.units }}
      </div>
      <!-- </el-form-item> -->

      <!-- <el-form-item> -->
      <el-button @click="submitForm('ruleForm')" class="token-createBtn">
        发布合约
      </el-button>
      <!-- </el-form-item> -->

      <el-form-item>
        <div class="token-alert">
          本工具只用于区块链学习测试，如用于违法活动，与本站无关
        </div>
      </el-form-item>
    </el-form>
    <DeployAlert
      :visible.sync="showDeploy"
      :tokenForm="tokenForm"
      :contractData="contractData"
      :deployData="deployData"
    ></DeployAlert>
    <LoadingAlert
      :visible.sync="showLoading"
      :LoadingText="loadingText"
    ></LoadingAlert>
  </div>
</template>
<script>
import DeployAlert from "@/components/alert/deployAlert";
import LoadingAlert from "@/components/alert/loading";
import { getPredictContractAddr, sendTransaction } from "@/config/wallet.js";
import {
  compilerContract,
  saveContractRecord,
  updateContractRecord,
  consoleDetail,
} from "@/config/api.js";

export default {
  components: {
    DeployAlert,
    LoadingAlert,
  },
  data() {
    return {
      gasConfig: this.$getGasConfig("base"),
      showDeploy: false,
      finishDeployed: false,
      contractAddr: "",
      contractData: { contractCode: "base" },
      deployData: [],
      tokenForm: {
        name: "Standard Coin",
        symbol: "STD",
        total: 10000,
        decimals: 18,
        website: "",
        telegram: "",
        twitter: "",
        discord: "",
        introduction: "",
      },
      account: localStorage.getItem("TokenBox-account"),
      tokenRules: {
        name: [{ required: true, message: "请输入全称", trigger: "change" }],
        symbol: [{ required: true, message: "请输入简称", trigger: "change" }],
        total: [{ required: true, message: "请输入数值", trigger: "change" }],
      },
      optionalContent: false,

      showLoading: false,
      loadingText: null,
    };
  },
  async beforeMount() {
    if (this.$route.query.contractId && this.$route.query.hash) {
      this.contractData.contractId = this.$route.query.contractId;
      var res = await consoleDetail({
        contractId: this.$route.query.contractId,
      });
      if (res&&res.data) {
        this.tokenForm = JSON.parse(res.data.content);
      }
      this.payContractGas();
    }
  },
  methods: {
    async submitForm(formName) {
      var account = localStorage.getItem("TokenBox-account");
      if (!account || account.length == 0) {
        this.showLoading = false;
        this.$message({
          message: "请先连接钱包",
          type: "warning",
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.payContractGas();
          return;
        } else {
          this.$message({
            message: "请输入完整",
            type: "warning",
          });
          console.log("error submit!!");
          return false;
        }
      });
    },
    async payContractGas() {
      //支付服务费
      this.showLoading = true;
      var res = null;
      var param = null;
      if (this.$route.query.contractId && this.$route.query.hash) {
        param = { transactionHash: this.$route.query.hash };
      }
      if (!param) {
        this.loadingText = "正在请求钱包交易";
        try {
          var tx = await sendTransaction(
            this.account,
            this.gasConfig.collectionAddress,
            this.gasConfig.price
          );
          this.loadingText = "交易已提交，等待区块确认";
          res = await tx.wait();
          console.log("交易已完成=", res);
        } catch (error) {
          this.showLoading = false;
          this.$showErrorMessage(error)
          return
        }
      } else {
        res = param;
      }
      console.log("sendTransaction=", res);

      //编译合约，从server端获取合约abi以及code
      var data = {
        contractCode: this.contractData.contractCode,
        argument: {
          name: this.tokenForm.symbol,
          website: this.tokenForm.symbol,
          telegram: this.tokenForm.telegram,
          twitter: this.tokenForm.twitter,
          discord: this.tokenForm.discord,
          description: this.tokenForm.introduction,
        },
        chainId: localStorage.getItem("TokenBox-chainID"),
        hash: res.transactionHash,
      };
      console.log(data);
      var res2 = await compilerContract(JSON.stringify(data));
      console.log("compilerContract=", res2);
      if (res2 && res2.code == 200200) {
        this.contractData.abi = res2.data.abi;
        this.contractData.bin = res2.data.bin;
        this.contractData.content = res2.data.content;
        this.contractData.contractAddr = await getPredictContractAddr(
          this.account
        );
        this.saveRecord(res.transactionHash,!param?0:1);
        //合约发布所需参数
        this.deployData = [
          [this.tokenForm.name, this.tokenForm.symbol],
          [],
          [this.tokenForm.decimals, this.tokenForm.total],
          [],
        ];
        //显示发布合约弹窗
        this.showDeploy = true;
      } else {
        this.$message({
          message: "请求失败",
          type: "warning",
        });
      }
      this.showLoading = false;
    },
    async saveRecord(hash, type) {
      var data = {
        contractAddress: this.contractData.contractAddr,
        name: this.tokenForm.name,
        symbol: this.tokenForm.symbol,
        template: this.contractData.contractCode,
        owner: this.account,
        chainId: localStorage.getItem("TokenBox-chainID"),
        hash: hash,
        content: JSON.stringify(this.tokenForm),
      };
      if (type == 1) {
        //更新发布记录
        data.contractId = parseInt(this.contractData.contractId);
        updateContractRecord(JSON.stringify(data));
      } else {
        //保存发布记录
        var saveRes = await saveContractRecord(JSON.stringify(data));
        if (saveRes&&saveRes.data.contractId) {
          this.contractData.contractId = saveRes.data.contractId;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  position: relative;
  width: calc(100% - 30%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 15% 0 15%;

  .token-form {
    width: 100%;
    margin: 40px 0 0 0;

    .token-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 4% 0 0 0;
    }

    .token-advantages {
      font-weight: normal;
      font-size: 12px;
      color: #8f8f8f;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 18px 0 0 0;

      span {
        margin: 0 10px 0 10px;
      }
    }
    /deep/.el-input__inner {
      height: 46px;

      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-textarea__inner {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input__count {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-form-item__label {
      font-weight: normal;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-input-number__decrease {
      width: 58px;
      height: 44px;
      background: #444170;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #7d77c0;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-minus {
        font-size: 24px;
        color: #d9d9d9;
      }
    }
    /deep/.el-input-number__decrease:hover {
      border: 1px solid #aba4ff;
    }

    /deep/.el-input-number__increase {
      width: 58px;
      height: 44px;
      background: #444170;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #7d77c0;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-plus {
        font-size: 24px;
        color: #cdc9ff;
      }
    }
    /deep/.el-input-number__increase:hover {
      border: 1px solid #aba4ff;
    }
    /deep/.el-input-number {
      width: 332px;
    }
    .token-inputNumber {
      /deep/.el-input__inner {
        text-align: center;
      }
    }

    .token-optionalContent {
      span {
        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 0 0 0 12px;
        cursor: pointer;
      }
    }

    .token-cost {
      font-weight: normal;
      font-size: 12px;
      color: #ffffff;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 20px 0;
    }

    .token-createBtn {
      width: 228px;
      height: 46px;
      background: #4438d4;
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #695cff;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 0 auto 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .token-createBtn:hover {
      border: 1px solid #aba4ff;
    }

    .token-alert {
      margin-top: 30px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }

  .form-labelHorizontal {
    display: flex;
    align-items: center;

    /deep/.el-form-item__label {
      padding: 0 12px 0 0;
    }
  }
}
.deploy-body {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  padding: 7% 20%;

  .alert {
    width: 50%;
    height: 100%;
    background: #fff;
    border-radius: 20px 20px 20px 20px;
    color: black;
    padding: 50px 80px;
    .close {
      font-size: 30px;
      border: #000 solid 1px;
      width: 30px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      border-radius: 20px;
      float: right;
      margin: -30px -50px 0 0;
    }
  }
  .title {
    font-weight: normal;
    font-size: 20px;
    color: #000;
    line-height: 23px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 30px 0 50px 0;
  }
  .text {
    margin: 50px 0 10px 0;
  }
  .address {
    width: 85%;
    padding: 0 10px;
    line-height: 45px;
    height: 45px;
    background: #e9e6e6;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #999797;
  }
  .copyAddress {
    color: #7d77c0;
    line-height: 45px;
    height: 45px;
    margin-left: 15px;
    cursor: pointer;
  }
  .copy {
    color: #ffffff;
    //background: rgb(189, 170, 204);
    background: #4339b6;
    border-radius: 4px;
    border: 1px solid #aba4ff;
    padding: 10px 20px;
    line-height: 60px;
    margin-right: 20px;
    white-space: nowrap;
    cursor: pointer;
  }
  .parameter {
    background: #918cd4;
    border-radius: 4px;
    border: 1px solid #7d77c0;
    padding: 10px 20px;
    line-height: 60px;
    margin-right: 20px;
    white-space: nowrap;
    color: #ffffff;
  }

  .createBtn {
    width: 228px;
    height: 46px;
    background: #4438d4;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid #695cff;

    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin: 100px auto 0 auto;
    cursor: pointer;
  }

  .createBtn2 {
    width: 228px;
    height: 46px;
    background: #4438d4;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid #695cff;

    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    text-transform: none;

    display: flex;
    justify-content: center;
    align-items: center;

    margin: 100px auto 0 auto;
    cursor: pointer;
  }
}

</style>